import { enableSideNavigation } from '../featureFlags'

/** Props applied to some Container components when rendering with the legacy top navigation. */
export const legacyLayoutProps = enableSideNavigation
  ? {}
  : ({
      className: 'my-4 offset-xl-1 col-xl-10',
      style: { flex: 1 },
    } as const)
